import { render, staticRenderFns } from "./Spreadsheet.vue?vue&type=template&id=1045aa7a&scoped=true&"
import script from "./Spreadsheet.vue?vue&type=script&lang=js&"
export * from "./Spreadsheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1045aa7a",
  null
  
)

export default component.exports